import MD5 from "./md5";
import config from "./config";
import { setCssVar } from '@/assets/style/color'
import moment from 'moment';

export function getConfig() {
    var host = document.domain
    switch (host) {
      case "mtest1.teacat.com":
        config.env = config.tcTestEnv
        break;
      case "mtest1.cotticoffee.com":
        config.env = config.cottiTestEnv
        getCottiColor()
        break;
      case "mdev.teacat.com":
        config.env = config.tcDevEnv
        break;
      case "mdev.cotticoffee.com":
        config.env = config.cottiDevEnv
        getCottiColor()
        break;
      case "mpre.teacat.com":
        config.env = config.tcPreEnv
        break;
      case "mpre.cotticoffee.com":
        config.env = config.cottiPreEnv
        getCottiColor()
        break;
      case "m.teacat.com":
        config.env = config.tcProdEnv
        break;
      case "m.cotticoffee.com":
        config.env = config.cottiProdEnv
        getCottiColor()
        break;
      case "mobile.cotticoffee.com":
        config.env = config.cottiProdEnv
        getCottiColor()
        break;
      default:
        config.env = config.cottiDevEnv
        getCottiColor()
        break;
    }
}
export function getCottiColor () {
  setCssVar('--primary-color', '#A52337')
  setCssVar('--text-base-color', '#A52337')
  setCssVar('--title-color', '#3A3B3C')
  setCssVar('--text-color', '#979797')
  setCssVar('--background-color', '#f5f6f7')
  setCssVar('--coupon-toast-color', '#333333')
}

export function getSignParams(path, runConfig) {
    const appKey = runConfig.ak;
    const signKey = runConfig.sk;
    const timestamp = new Date().getTime();
    const version = runConfig.version;
    const signMap = {
        timestamp,
        path,
        version,
    };
    const computeSign = [];
    Object.keys(signMap)
        .sort()
        .forEach((key) => {
            const val = signMap[key];
            if (val) {
                computeSign.push(`${key}${val}`);
            }
        });
    computeSign.push(signKey);
    return {
        timestamp,
        appKey,
        sign: MD5.hex_md5_32Upper(computeSign.join("")),
        version,
    };
}

export function isCottiApp() {
    const userAgent = navigator.userAgent;
    return userAgent?.includes(config.env.VUE_APP_COTTI_UA)
}

export function isWxMiniProgram() {
  return /miniProgram/i.test(navigator.userAgent.toLowerCase());
}

export function isAliPayProgram() {
  return /aliapp/i.test(navigator.userAgent.toLowerCase());
}

export function isWeixin() {
    const userAgent = navigator.userAgent;
    return userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function isAlipayClient() {
    const userAgent = navigator.userAgent;
    return userAgent.indexOf("AliApp") !== -1;
}

export function isAndroid() {
    const userAgent = navigator.userAgent;
    return userAgent.indexOf("Android") > -1 || userAgent.indexOf("Linux") > -1;
}

export function isIOS() {
    const userAgent = navigator.userAgent;
    return !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

export function isWeixinVersion7012() {
    const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
    );
    if (!wechatInfo) return
    console.log(wechatInfo);
    const judgewechat = wechatInfo[1].split(".");
    if (judgewechat[0] > 7) {
        return true;
    } else if (judgewechat[0] === 7) {
        if (judgewechat[1] > 1) {
            return true;
        } else if (judgewechat[1] === 1) {
            if (judgewechat[2] >= 12) {
                return true;
            }
        }
    }
    return false;
}

export const getUrlParam = name => {
    // 给定URL参数名称取得对应的参数
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    if (reg.test(location.search.substr(1))) {
        return decodeURIComponent(RegExp.$2)
    } else if (reg.test(location.hash.substr(location.hash.indexOf('?') + 1))) {
        return decodeURIComponent(RegExp.$2)
    } else {
        return ''
    }
}
export const replaceParamVal =(url,paramName,replaceVal) =>{
    const oUrl = url.toString();
    const reg=new RegExp('/('+ paramName+'=)([^&]*)/gi');
    return oUrl.replace(reg, paramName + '=' + replaceVal);
}

export const goAppStore = () => {
    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
    if (typeof hidden == "undefined" || hidden == false) {
        if (isAndroid()) {
            // 跳转android应用商店
            // window.location.href  = "https://a.app.qq.com/o/simple.jsp?pkgname="
        } else if (isIOS()) {
            //App store下载地址
            if(config.env.VUE_APP_BRAND == "COTTI") {
              window.location.href = "https://apps.apple.com/cn/app/id1661236690";
            } else {
              window.location.href = "https://apps.apple.com/cn/app/id6473227178";
            }

        }
    }
}

/**
 * 拉起app通用方法
 * @param type string url上用于描述跳转类型的枚举值 PAGES
 * @param params string 是使用base64加密的object，内容应该与app生成的保持一致
 * @param needDownload 如果拉起失败，是否需要跳转到登录页面
 */
 export const launchApp = (type, params, needDownload = false) => {
  console.log(params,'paramsparamsparamsparams')
    if (navigator.userAgent?.includes(config.env.VUE_APP_COTTI_UA)) {
      console.log(navigator.userAgent, 'navigator.userAgent')
      return
    }
    const t = getUrlParam('t')
    const q = getUrlParam('q')
    try {
      const appUrlScheme = config.env.VUE_APP_IOS_SCHEME
      const anUrlScheme = config.env.VUE_APP_AN_SCHEME
      // console.log(urlScheme, 'urlScheme')
      const appDownload = '/#/download'
      if (type && params) {
        var loadDateTime = new Date();
        if (isIOS()) {
          window.location.href = appUrlScheme + `?t=${type}&q=${params}`
        } else {
          window.location.href = anUrlScheme + `?t=${type}&q=${params}`
        }
        window.setTimeout(function() { //如果没有安装app,便会执行setTimeout跳转下载页
            var timeOutDateTime = new Date();
            if (timeOutDateTime - loadDateTime < 5000) {
                if (isIOS()) {
                  if(config.env.VUE_APP_BRAND == "COTTI") {
                    window.location.href = "https://apps.apple.com/cn/app/id1661236690";
                  } else {
                    window.location.href = "https://apps.apple.com/cn/app/id6473227178";
                  }
                } else {
                  window.location.href = appDownload
                }
            } else {
                window.close();
            }
        }, 500);
        return
      }
      if (t && q) {
        var loadDateTime = new Date();
        window.location.href = appUrlScheme + `?t=${t}&q=${q}`
        window.setTimeout(function() { //如果没有安装app,便会执行setTimeout跳转下载页
            var timeOutDateTime = new Date();
            if (timeOutDateTime - loadDateTime < 5000) {
                if (isIOS()) {
                  if(config.env.VUE_APP_BRAND == "COTTI") {
                    window.location.href = "https://apps.apple.com/cn/app/id1661236690";
                  } else {
                    window.location.href = "https://apps.apple.com/cn/app/id6473227178";
                  }
                } else {
                  window.location.href = appDownload
                }
            } else {
                window.close();
            }
        }, 500);
        return
      }
      var loadDateTime = new Date();
      window.location.href = urlScheme
      window.setTimeout(function() { //如果没有安装app,便会执行setTimeout跳转下载页
        var timeOutDateTime = new Date();
        if (timeOutDateTime - loadDateTime < 5000) {
            if (isIOS()) {
              if(config.env.VUE_APP_BRAND == "COTTI") {
                window.location.href = "https://apps.apple.com/cn/app/id1661236690";
              } else {
                window.location.href = "https://apps.apple.com/cn/app/id6473227178";
              }
            } else {
              window.location.href = appDownload
            }
        } else {
            window.close();
        }
    }, 500);
    } catch (e) {
      console.warn('urlScheme 跳转错误', e)
      if (!needDownload) {
        return
      }
      if (type && params) {
        window.location.href = `/#/download?t=${type}&q=${params}`
        return
      }
      if (t && q) {
        window.location.href = `/#/download?t=${t}&q=${q}`
        return
      }
      window.location.href = `/#/download`
    }
  }

  /**
 * 拉起app通用方法
 * @param type string url上用于描述跳转类型的枚举值 PAGES
 * @param params string 是使用base64加密的object，内容应该与app生成的保持一致
 * @param needDownload 如果拉起失败，是否需要跳转到登录页面
 */
 export const launchAppLottery = (type, params, needDownload = false) => {
  if (navigator.userAgent?.includes(config.env.VUE_APP_COTTI_UA)) {
    console.log(navigator.userAgent, 'navigator.userAgent')
    return
  }
  const t = getUrlParam('t')
  const q = getUrlParam('q')
  try {
    const appUrlScheme = config.env.VUE_APP_IOS_SCHEME
    const anUrlScheme = config.env.VUE_APP_AN_SCHEME
    // console.log(urlScheme, 'urlScheme')
    const appDownload = '/#/download'
    if (type && params) {
      var loadDateTime = new Date();
      if (isIOS()) {
        window.location.href = appUrlScheme + `?t=${type}&q=${params}`
      } else {
        window.location.href = anUrlScheme + `?t=${type}&q=${params}`
      }
      return
    }
    if (t && q) {
      var loadDateTime = new Date();
      window.location.href = appUrlScheme + `?t=${t}&q=${q}`
      return
    }
    var loadDateTime = new Date();
    window.location.href = appUrlScheme
  } catch (e) {
    console.warn('urlScheme 跳转错误', e)
    if (!needDownload) {
      return
    }
    if (type && params) {
      // window.location.href = `/#/download?t=${type}&q=${params}`
      return
    }
    if (t && q) {
      // window.location.href = `/#/download?t=${t}&q=${q}`
      return
    }
    // window.location.href = `/#/download`
  }
}

  export function formatDateToMDHMS(date, type) {
    const date1 = moment(date)
    const formattedDate = date1.format('M月D日 HH:mm')
    return formattedDate
  }


function setPageTitleInApp(title) {
    console.log('setPageTitleInApp ', title)
    if (isCottiApp()) {
        try {
            TitleChange.postMessage(`{"title":"${title}"}`);
        } catch (e) {
            console.error('setPageTitleInApp e = ', e)
        }
    }
}
function setPageTitleInMiniApp(title) {
    try {
        document.title = title;
        AlipayJSBridge.call('setTitle', { title: title });
    } catch (e) {
        console.log(e);
    }
}

export function setPageTitle(title) {
    setPageTitleInMiniApp(title);
    setPageTitleInApp(title)
}

